import "./Inventory.css";

import { LogoutDarkIcon } from "../../../../assets";
import { OrganisationTypeConstants } from "../../../../constants";
import {
  Column,
  CursorDataGrid,
  InventorySelector,
  MultiSelect,
  Row,
  Select,
  StackedBarChart,
} from "../../../../widget";
import { InventoryChartKey } from "../../inventory/inventory-management-board/components";
import { useInventory } from "./useInventory";

const Inventory = (): JSX.Element => {
  const {
    hasData,
    hasEnoughDataForScrolling,
    gridOnChange,
    isReadableProject,
    isLoading,
    dropDownData,
    selectedUnitMeasurementData,
    handleUpdateSelectedUnitMeasurement,
    activeSelectOptionText,
    setActiveSelectOptionText,
    inventorySelectorButtons,
    pageData,
    columns,
    onTagsFilter,
    tagsFilterData,
    tagsFilterSelectedData,
    currentUserType,
    // eslint-disable-next-line no-undef
  } = useInventory();

  return (
    <div className="TemplateTabCard LandholdingInventory">
      <div className="InventoryHeaderContainer">
        <h2>{`${selectedUnitMeasurementData === "" ? "Overall" : selectedUnitMeasurementData} inventory: ${activeSelectOptionText.toLowerCase()}`}</h2>
        <div className="HeaderButtons">
          <h3>Display</h3>
          <Select
            onChange={(v) => {
              handleUpdateSelectedUnitMeasurement(v);
            }}
            data={dropDownData}
            value={selectedUnitMeasurementData}
            className="HeaderSelect"
          />
          {selectedUnitMeasurementData !== "" && (
            <InventorySelector
              buttons={inventorySelectorButtons}
              activeSelector={activeSelectOptionText}
              onChange={setActiveSelectOptionText}
            />
          )}
        </div>
      </div>
      {hasData && (
        <>
          <Row spacingV="s">
            <Column span={12}>
              <StackedBarChart
                xLabels={pageData.chartLabels}
                data={pageData.chartData ?? []}
                hasYAxisGridLines
                hasYAxisTicks
                showLegend={false}
              />
              <InventoryChartKey
                unitMeasurement={selectedUnitMeasurementData}
                isSalesOverTime={false}
                showAllocatedAndAvailable={!isReadableProject}
              />
            </Column>
          </Row>
          <div className="InventoryFilters">
            <h3>Filter by</h3>
            <MultiSelect
              label=" "
              className="TagsFilter"
              placeholder="Tags"
              data={tagsFilterData}
              onChange={(keys) => onTagsFilter(keys)}
            />
          </div>
        </>
      )}
      <Row spacingV={hasEnoughDataForScrolling ? "3xl" : undefined}>
        <Column span={12}>
          <div className={`InventoryDataGrid ${hasEnoughDataForScrolling ? "Scrollable" : ""}`}>
            <CursorDataGrid
              key={selectedUnitMeasurementData + activeSelectOptionText + tagsFilterSelectedData}
              onChange={gridOnChange}
              columns={columns}
              clientSide={false}
              filterable
              pagination={{ pageSize: 1000 }}
              filterPosition={hasData ? "inventory" : "left"}
              dataIsLoading={isLoading}
              data={[]}
              noDataMessage="No inventory data to display"
              exportable
              exportButtonText="Export table"
              exportButtonIcon={<LogoutDarkIcon className="ExportButtonIcon" />}
              exportFileName=""
              infiniteScroll
              hasTotalRow
              totalColumnNames={
                isReadableProject
                  ? ["availableUnits", "reservedUnits", "soldUnits"]
                  : ["allocatedUnits", "availableUnits"]
              }
              variant={currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "seed" : "default"}
            />
          </div>
        </Column>
      </Row>
    </div>
  );
};

export default Inventory;
